import { addToast, Icon, Table } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTexts } from '../hooks/useTexts';
import { getStudentDocumentDownload } from '../../../api/studentDocumentsRequests';
import { StudentDocument } from '../types';

type DocumentsOthersTableProps = {
  studentId: number;
  data: StudentDocument[];
  onDelete: (document: StudentDocument) => void | Promise<void>;
  hasPermissionToDelete?: boolean;
};

export function DocumentsOthersTable({
  studentId,
  data,
  onDelete,
  hasPermissionToDelete,
}: DocumentsOthersTableProps) {
  const texts = useTexts();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const getUrl = async (studentDocumentId: number) => {
    setLoading(true);
    const result = await getStudentDocumentDownload({
      studentId,
      studentDocumentId,
    });
    const { error, data } = result;
    setLoading(false);
    if (error && error.code === 'CONNECTION') {
      addToast({
        icon: 'error',
        color: 'danger',
        text: 'error de conexión',
      });
    } else if (error) {
      addToast({
        icon: 'error',
        color: 'danger',
        text: t('common.errors.get'),
      });
    }
    if (data) {
      window.open(data.url, '_blank');
    }
  };

  return (
    <Table
      data={data}
      noResultsText={texts.noResults}
      columns={[
        {
          headerText: texts.documentsOthersTable.name,
          columnName: 'name',
          width: '33%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.documentsOthersTable.description,
          columnName: 'description',
          width: '33%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.documentsOthersTable.fileName,
          columnName: 'filename',
          width: '33%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.documentsOthersTable.action,
          columnName: 'a',
          width: '100px',
          thClassName: 'text-center',
          tdClassName: 'text-center',
          cellFormat({ row }) {
            return (
              <>
                <button
                  type="button"
                  className="btn"
                  onClick={() => getUrl(row.id)}
                  disabled={loading}
                >
                  <Icon name="download" color="primary" />
                </button>
                {hasPermissionToDelete && (
                  <button
                    type="button"
                    className="btn"
                    onClick={() => onDelete(row)}
                  >
                    <Icon name="trash" color="primary" />
                  </button>
                )}
              </>
            );
          },
        },
      ]}
    />
  );
}
